var map = {
	"./a1.jpg": 1162,
	"./img-01.jpg": 806,
	"./img-02.jpg": 394,
	"./img-03.jpg": 807,
	"./img-04.jpg": 808,
	"./profilelogo.png": 1163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2427;